// Picks the best way to get a Tesla (or other dashcam) event's files from a USB drive into the browser.
// The ladder: showDirectoryPicker, then <input webkitdirectory>, then multi-select, then a guided copy-to-Files panel.

import { supportsDirectoryPicker } from '@/utils/vendors/tesla-folder'

export type PickMethod = 'directory-picker' | 'directory-input' | 'multi-select' | 'guided'
export type GuidePlatform = 'ios' | 'android'

export interface PickCapabilities {
  directoryPicker: boolean
  directoryInput: boolean
  multiSelect: boolean
}

const LADDER: Array<{ method: Exclude<PickMethod, 'guided'>; cap: keyof PickCapabilities }> = [
  { method: 'directory-picker', cap: 'directoryPicker' },
  { method: 'directory-input', cap: 'directoryInput' },
  { method: 'multi-select', cap: 'multiSelect' }
]

export function detectPickCapabilities(
  win: Window = window,
  doc: Document = document
): PickCapabilities {
  const input = doc.createElement('input')
  return {
    directoryPicker: supportsDirectoryPicker(win),
    directoryInput: 'webkitdirectory' in input,
    multiSelect: 'multiple' in input
  }
}

/** The first available rung that has not failed this session, else the guided panel. */
export function choosePickMethod(caps: PickCapabilities, failed: PickMethod[] = []): PickMethod {
  const rung = LADDER.find((r) => caps[r.cap] && !failed.includes(r.method))
  return rung?.method ?? 'guided'
}

/** iPadOS Safari reports a Mac UA, so a Mac with touch points counts as iOS. */
export function guessGuidePlatform(ua: string, maxTouchPoints: number): GuidePlatform {
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios'
  if (/Macintosh/i.test(ua) && maxTouchPoints > 1) return 'ios'
  return 'android'
}
